export enum MeetingLocation {
	CLIENT_HOME = 1,
	FUNERAL_HOME = 2,
	CLIENT_HOME_AND_FUNERAL_HOME = 3,
	OTHER = 4,
	PHONE = 5,
}
